import { IconSize } from '../Icons/IconWrap';
export var getIconSizeForButtonSize = function (buttonSize) {
    return buttonSize === 'small' ? IconSize.SMALLER : IconSize.MEDIUM;
};
//# sourceMappingURL=helpers.js.map